import Stack from "@mui/material/Stack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import SensorsIcon from "@mui/icons-material/Sensors";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Logo } from "./mainGridComponents/logo.component";
import { useNavigate } from "react-router";

export default function DigitalTwinHeader() {
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1300,
        display: { xs: "none", md: "flex" },
        width: "100%",
        height: "60px",
        transform: "rotate(0deg)",
        opacity: 1,
        alignItems: "center",
        justifyContent: "space-between",
        p: 1,
        background: (theme) => theme.palette.background.default,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
      spacing={2}
    >
      {/* Left side: Logo and Button */}
      <Stack direction="row" sx={{ gap: 1, alignItems: "center", px: 2 }}>
        <Logo width="161px" height="auto" />
        <Button
          variant="outlined"
          endIcon={<NorthEastIcon />}
          onClick={() => {
            navigate(`/userLands`);
          }}
          sx={{
            textTransform: "none",
            fontStyle: "normal",
            fontWeight: "normal",
            width: "213px",
            minWidth: "213px",
            maxWidth: "213px",
          }}
        >
          Torna alla piattaforma
        </Button>
      </Stack>
      {/* Right side: Menu and Color Mode */}
      <Stack direction="row" sx={{ gap: 1, alignItems: "center", px: 2 }}>
        {/* <Button
          startIcon={<SensorsIcon />}
          sx={{
            textTransform: "none",
            width: "161px",
            minWidth: "161px",
            maxWidth: "161px",
          }}
        >
          Sistema online
        </Button> */}
        <Button
          variant="outlined"
          startIcon={<NotificationsActiveIcon />}
          sx={{
            textTransform: "none",
            width: "126px",
            minWidth: "126px",
            maxWidth: "126px",
            color: (theme) => theme.palette.error.main, // force text color
            borderColor: (theme) => theme.palette.error.main, // force border color
          }}
          color="error"
        >
          Allarmi (3)
        </Button>
        {/* profile button */}
        <Box
          sx={{
            pl: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "60px",
            height: "40px",
            borderRadius: "200px",
          }}
          onClick={() => {
            navigate(`/profile`);
          }}
        >
          <AccountCircleIcon sx={{ fontSize: "2rem" }} />
          <KeyboardArrowDownIcon />
        </Box>
      </Stack>
    </Stack>
  );
}
